module.exports = __webpack_public_path__ + "static/media/patrol(22).b47248e1.PNG";